import axios from "axios";

export default function EntrylogDownloadReportService() {
  return axios.get(process.env.REACT_APP_API_HOST + "/report/entry_location_checked", {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
